import React, { Component } from 'react';
import styles from './Footer.module.scss';

export class Footer extends Component {
  get currentYear() {
    return new Date().getFullYear();
  }

  render() {
    return (
      <footer className={styles.footer}>
        <div className={styles.container}>
          {/* Main Footer Content */}
          <div className={styles.footerMain}>
            {/* Company Info */}
            <div className={styles.footerSection}>
              <div className={styles.logo}>
                <img 
                  src="/images/chatup24-logo.png" 
                  alt="Chatup24" 
                  className={styles.logoImage}
                />
              </div>
              <p className={styles.description}>
                Chatup24 closes the gap between you and the places you visit — call staff,
                order, and chat in seconds, right from your seat. Fast, friendly service,
                the moment you need it.
              </p>
              <div className={styles.socialLinks}>
                <a href="#" className={styles.socialLink} aria-label="Facebook">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
                <a href="#" className={styles.socialLink} aria-label="Twitter">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                  </svg>
                </a>
                <a href="#" className={styles.socialLink} aria-label="Instagram">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 6.62 5.367 11.987 11.988 11.987s11.987-5.367 11.987-11.987C24.014 5.367 18.647.001 12.017.001zM8.449 16.988c-1.297 0-2.448-.49-3.323-1.297C4.198 14.895 3.708 13.744 3.708 12.447s.49-2.448 1.418-3.323c.875-.807 2.026-1.297 3.323-1.297s2.448.49 3.323 1.297c.928.875 1.418 2.026 1.418 3.323s-.49 2.448-1.418 3.244c-.875.807-2.026 1.297-3.323 1.297zm7.83-9.281h-1.563c-.104 0-.187-.083-.187-.187V6.359c0-.104.083-.187.187-.187h1.563c.104 0 .187.083.187.187v1.161c0 .104-.083.187-.187.187zm-7.83 1.297c-.719 0-1.297.578-1.297 1.297s.578 1.297 1.297 1.297 1.297-.578 1.297-1.297-.578-1.297-1.297-1.297zm7.83 1.297h-1.563c-.104 0-.187-.083-.187-.187v-1.161c0-.104.083-.187.187-.187h1.563c.104 0 .187.083.187.187v1.161c0 .104-.083.187-.187.187z"/>
                  </svg>
                </a>
                <a href="#" className={styles.socialLink} aria-label="YouTube">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                  </svg>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className={styles.footerSection}>
              <h3 className={styles.sectionTitle}>Quick Links</h3>
              <ul className={styles.footerLinks}>
                <li><a href="#home" className={styles.footerLink}>Home</a></li>
                <li><a href="#about" className={styles.footerLink}>About Us</a></li>
                <li><a href="#tables" className={styles.footerLink}>Book Table</a></li>
                <li><a href="#tournaments" className={styles.footerLink}>Tournaments</a></li>
                <li><a href="#coaching" className={styles.footerLink}>Coaching</a></li>
                <li><a href="#vip" className={styles.footerLink}>VIP Lounge</a></li>
              </ul>
            </div>

            {/* Services */}
            <div className={styles.footerSection}>
              <h3 className={styles.sectionTitle}>Services</h3>
              <ul className={styles.footerLinks}>
                <li><a href="#tournament-tables" className={styles.footerLink}>Tournament Tables</a></li>
                <li><a href="#standard-tables" className={styles.footerLink}>Standard Tables</a></li>
                <li><a href="#private-events" className={styles.footerLink}>Private Events</a></li>
                <li><a href="#lessons" className={styles.footerLink}>Pool Lessons</a></li>
                <li><a href="#equipment" className={styles.footerLink}>Equipment Rental</a></li>
                <li><a href="#catering" className={styles.footerLink}>Catering</a></li>
              </ul>
            </div>

          </div>

          {/* Footer Bottom */}
          <div className={styles.footerBottom}>
            <div className={styles.footerBottomContent}>
              <div className={styles.legalLinks}>
                <a href="/privacy" className={styles.legalLink}>Privacy Policy</a>
                <a href="/terms" className={styles.legalLink}>Terms of Service</a>
                <a href="/cookie-policy" className={styles.legalLink}>Cookie Policy</a>
              </div>
            </div>
            {/* Legal identity (UAE registered entity) */}
            <div className={styles.legalIdentity}>
              <p className={styles.legalEntity}>Chatup24 Global Technologies L.L.C-FZ</p>
              <p className={styles.legalMeta}>© {this.currentYear} Chatup24 Global Technologies L.L.C-FZ. All rights reserved.</p>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}